import React from 'react';
import { evaluateCondition } from '../buybox.view';
import { logDetails } from '../../../../utils/debug-mode';
import { IInfoListData } from '../../definition-extensions/buybox.ext.props.autogenerated';
import { RichTextComponent } from '@msdyn365-commerce/core';

export interface IBuyBoxConfigurator {
    Model: {
        $: {
            name: string;
        };
        EnumDomain: {
            $: {
                name: string;
                enumDomainId: string;
            };
            EnumValue: {
                $: {
                    value: string;
                    displayValue: string;
                };
            }[];
        }[];
        Component: {
            $: {
                name: string;
                componentId: string;
                instanceId: string;
            };
            Attribute: {
                $: {
                    name: string;
                    displayName: string;
                    uniqueId: string;
                    instanceId: string;
                    type: string;
                    default?: string;
                };
                EnumDomain: {
                    $: {
                        domain: string;
                        enumDefinitionId: string;
                    };
                }[];
                MandatoryModifier: string[];
            }[];
            TableConstraint: {
                $: {
                    name: string;
                    uniqueId: string;
                };
                Column: {
                    Attribute: {
                        $: {
                            name: string;
                        };
                    }[];
                }[];
                Row: {
                    Cell: string[];
                }[];
            }[];
            CustomerPrice: {
                Customer: {
                    $: {
                        Relation: string;
                        Account: string;
                        ItemId: string;
                        MinQty: string;
                        MaxQty: string;
                        DiscountPercent: string;
                        Price: string;
                        FromDate: string;
                        ToDate: string;
                    };
                }[];
            }[];
            PriceCalculation: {
                $: {
                    id: string;
                    name: string;
                    condition: string;
                    expression: string;
                };
            }[];
            OperationLine?: {
                $: {
                    name: string;
                    uniqueId: string;
                };
                Condition: {
                    $: {
                        constraintId: string;
                        uniqueId: string;
                        constraintText: string;
                    };
                }[];
            }[];
            SubPart?: {
                $: {
                    name: string;
                    uniqueId: string;
                };
                Condition: {
                    $: {
                        constraintId: string;
                        uniqueId: string;
                        constraintText: string;
                    };
                }[];
            }[];
            HiddenAttribute: IHiddenAttribute[];
            HiddenAttributeValue?: {
                Attribute: {
                    $: {
                        name: string;
                        displayName: string;
                        domain: string;
                        uniqueId: string;
                        value: string;
                    };
                }[];
            }[];
        }[];
    };
}

export interface IHiddenAttribute {
    Attribute: {
        $: {
            name: string;
            displayName: string;
            uniqueId: string;
            ecomHideOnly: string;
        };
    }[];
}

type BuyBoxSelectorProps = {
    attribute: IBuyBoxAttribute;
    children: React.ReactNode;
    onValueChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    configValue: {
        [key: string]: string;
    };
    hiddenAttributes: IHiddenAttribute[];
    faqLink?: string;
    possibleValues: {
        [key: string]: string;
    };
    props: any;
    infoList?: IInfoListData[] | undefined;
};

export const BuyBoxSelector = (props: BuyBoxSelectorProps) => {
    const { children, attribute, onValueChange, hiddenAttributes, faqLink, possibleValues, infoList } = props;

    let hideAttribute = false;

    if (hiddenAttributes && hiddenAttributes.length > 0) {
        hiddenAttributes.map(a => {
            a.Attribute.map(b => {
                if (b.$.name === attribute.$.name) {
                    hideAttribute = true;
                }
            });
        });
    }

    if (hideAttribute) {
        // removeSearchParams(attribute.$.name);
        return <></>;
    }

    if (attribute.MandatoryModifier)
        if (attribute.MandatoryModifier[0] !== '' && attribute.HiddenModifier) {
            if (typeof attribute.MandatoryModifier[0] !== 'string') {
                try {
                    const data = attribute.HiddenModifier[0].Condition[0].$;

                    // Check if the condition is true for the given data

                    if (evaluateCondition(data.constraintText, possibleValues)) {
                        // If true, calculate the expression
                        removeSearchParams(attribute.$.name);
                        return <></>;
                    } else {
                    }
                } catch (e) {
                    logDetails(props.props.context.app.config.debugMode, e);
                }

                // if(attribute.HiddenModifier[0].Condition[0].$.constraintText)
            } else {
                return <></>;
            }
        }

    return (
        <div key={attribute.$.name} className='ml_buybox__form-container'>
            <div className='ml_buybox__dropdown-container ml_buybox__col-sm-12'>
                <div className='ml_buybox-label-question_mark_container'>
                    <label className='ms-buybox__dropdown-quantity-label' htmlFor={attribute.$.displayName}>
                        <div className='ml_buybox__field-label'>
                            Select {attribute.$.displayName} <span className='ml-text-danger'>*</span>
                        </div>
                    </label>
                    <div className='ml_buybox__question-mark'>
                        <span>
                            <a href={`${faqLink}#select ${attribute.$.displayName}`} target='_blank'>
                                ?
                            </a>
                        </span>
                    </div>
                </div>
                <select
                    id={attribute.$.displayName}
                    aria-label='Configuration'
                    className='ml_buybox__dropdown'
                    data-value={attribute.$.name}
                    onChange={e => onValueChange(e)}
                    defaultValue={getSearchValue(attribute.$.name)}
                    required
                >
                    <option value=''>Choose {attribute.$.displayName}</option>
                    {children}
                </select>
            </div>
            <div className='ml_buybox__helper-block ml_buybox__col-sm-12'>
                {infoList &&
                    infoList.length > 0 &&
                    infoList.map(info => {
                        if (info.key && info.key.toLowerCase() === attribute.$.name.toLowerCase()) {
                            return <RichTextComponent text={info.text} />;
                        }
                        return null;
                    })}
            </div>
        </div>
    );
};

type BuyBoxSelectorChildrenProps = {
    children?: IBuyBoxAttributeChildren;
    attribute: IBuyBoxAttribute;
    constraints?: {
        [key: string]: string[];
    };
    applicable: string[];
};
export const BuyBoxSelectorChildren = (props: BuyBoxSelectorChildrenProps) => {
    const { applicable, attribute, children, constraints } = props;
    return (
        <>
            {children &&
                children.EnumValue.map(enumValue => {
                    if (constraints && attribute.$.name in constraints && constraints[attribute.$.name].includes(enumValue.$.value)) {
                        return (
                            <option key={enumValue.$.value} value={enumValue.$.value}>
                                {enumValue.$.displayValue}
                            </option>
                        );
                    } else if (!applicable.includes(attribute.$.name)) {
                        return (
                            <option key={enumValue.$.value} value={enumValue.$.value}>
                                {enumValue.$.displayValue}
                            </option>
                        );
                    } else {
                        return null;
                    }
                })}
        </>
    );
};

interface IBuyBoxAttribute {
    $: {
        name: string;
        displayName: string;
        uniqueId: string;
        instanceId: string;
        type: string;
        default?: string;
    };
    EnumDomain: {
        $: {
            domain: string;
            enumDefinitionId: string;
        };
    }[];
    MandatoryModifier:
        | string[]
        | {
              Condition: {
                  $: {
                      constraintId: string;
                      uniqueId: string;
                      constraintText: string;
                  };
              }[];
          }[];
    HiddenModifier?: {
        Condition: {
            $: {
                constraintId: number;
                uniqueId: number;
                constraintText: string;
            };
        }[];
    }[];
}

interface IBuyBoxAttributeChildren {
    $: {
        name: string;
        enumDomainId: string;
    };
    EnumValue: {
        $: {
            value: string;
            displayValue: string;
        };
    }[];
}

export const getURLSearchParams = () => {
    return new URLSearchParams(window.location.search);
};

export const removeSearchParams = (paramKey: string | undefined) => {
    const queryParams = getURLSearchParams();
    if (typeof paramKey === 'string') {
        queryParams.delete(paramKey);

        // Get the updated search string
        const updatedSearch = queryParams.toString();

        // Use window.history.pushState to update the URL without a full page reload
        const newURL = `${window.location.pathname}?${updatedSearch}`;

        window.history.pushState({ path: newURL }, '', newURL);
    }
};

export const updateSearchParams = (paramKey: string | undefined, value: string) => {
    const queryParams = getURLSearchParams();
    let returnValue = false;
    if (typeof paramKey === 'string') {
        for (const [key] of queryParams.entries()) {
            if (key === paramKey) {
                returnValue = true;
            }
        }
        queryParams.set(paramKey, value);

        // Get the updated search string
        const updatedSearch = queryParams.toString();

        // Use window.history.pushState to update the URL without a full page reload
        const newURL = `${window.location.pathname}?${updatedSearch}`;
        window.history.pushState({ path: newURL }, '', newURL);
    }
    returnValue;
};

export const resetSearchParams = () => {
    const newURL = `${window.location.pathname}`;
    window.history.pushState({ path: newURL }, '', newURL);
};
export const getSearchValue = (value: string) => {
    return getURLSearchParams().get(value) as string;
};
